// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="units.HighestPlayerUnitChart"></bfg-chart>
    </div>
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="units.HighestPlayerMedalChart"></bfg-chart>
    </div>
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="units.HighestPlayerEquipmentChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;